import React from "react";
import { Card, Button, Loader } from "ui-kit-ck-consultant";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSms,
  faEnvelope,
  faVideo,
  faCalendarAlt,
  faUndo,
} from "@fortawesome/free-solid-svg-icons";

import axiosConfig from "../../utils/axiosConfig";

import ModalSendEmail from "./ModalSendEmail";
import ModalSendSMS from "./ModalSendSMS";
import ModalAppointment from "./ModalAppointment";

export default class Contact extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoad: false,
      isModalSendEmail: false,
      isModalSendSMS: false,
      isModalAppointment: false,
    };
  }

  // Libellé du bouton RDV : "RDV : JJ/MM/AAAA à HH:MM" si un RDV est fixé.
  getAppointmentLabel = () => {
    const { dateAppointment, hourAppointment } = this.props;
    if (!dateAppointment || !hourAppointment) {
      return "Prendre le RDV";
    }
    const [year, month, day] = String(dateAppointment).split("-");
    const dateFR =
      year && month && day ? `${day}/${month}/${year}` : dateAppointment;
    const hour = String(hourAppointment).slice(0, 5);
    const suffix = this.props.appointmentCanceled ? " (annulé)" : "";
    return `RDV : ${dateFR} à ${hour}${suffix}`;
  };

  // Repasser en prise de RDV classique : on coupe la visio instantanée, le
  // lien client réaffiche alors le calendrier (ou la confirmation si RDV).
  stopInstantVisio = () => {
    this.setState({ isLoad: true }, () => {
      axiosConfig("folder/set-visio-instant", {
        data: { id: this.props.id, value: false },
      })
        .then((res) => {
          if (res.data && res.data.success) {
            this.props.getFolder(false);
            this.setState({ isLoad: false });
          } else {
            this.instantVisioError();
          }
        })
        .catch(this.instantVisioError);
    });
  };

  // Visio instantanée : aucun RDV, aucun créneau consommé. On bascule le
  // dossier en accès direct puis on ouvre la modale SMS pour envoyer le lien.
  startInstantVisio = () => {
    this.setState({ isLoad: true }, () => {
      axiosConfig("folder/set-visio-instant", {
        data: { id: this.props.id, value: true },
      })
        .then((res) => {
          if (res.data && res.data.success) {
            this.props.getFolder(false);
            this.setState({ isLoad: false, isModalSendSMS: true });
          } else {
            this.instantVisioError(res.data && res.data.message);
          }
        })
        .catch(this.instantVisioError);
    });
  };

  instantVisioError = (message) => {
    this.setState({ isLoad: false }, () =>
      alert(typeof message === "string" ? message : "Une erreur est survenue.")
    );
  };

  render() {
    return (
      <>
        <Card title="Contact" className="h-100">
          <Button
            className="mb-10 mb-20-xl"
            text={this.getAppointmentLabel()}
            disabled={this.props.status > 2}
            onClick={() => this.setState({ isModalAppointment: true })}
          >
            <FontAwesomeIcon icon={faCalendarAlt} />
          </Button>
          <Button
            className="mb-10 mb-20-xl"
            outline
            text="E-mail prise RDV"
            disabled={this.props.status > 2}
            onClick={() => this.setState({ isModalSendEmail: true })}
          >
            <FontAwesomeIcon icon={faEnvelope} />
          </Button>
          <Button
            className="mb-10 mb-20-xl"
            outline
            text="SMS prise RDV"
            disabled={this.props.status > 2}
            onClick={() => this.setState({ isModalSendSMS: true })}
          >
            <FontAwesomeIcon icon={faSms} />
          </Button>
          <Button
            className="mb-10 mb-20-xl"
            green
            text={
              this.props.visioInstant
                ? "SMS visio instantanée active — renvoyer le lien"
                : "SMS visio instantanée"
            }
            disabled={this.props.status > 2}
            onClick={this.startInstantVisio}
          >
            <FontAwesomeIcon icon={faVideo} />
          </Button>
          {this.props.visioInstant ? (
            <Button
              className="mb-10 mb-20-xl"
              outline
              text="Revenir à la prise de RDV"
              disabled={this.props.status > 2}
              onClick={this.stopInstantVisio}
            >
              <FontAwesomeIcon icon={faUndo} />
            </Button>
          ) : null}
        </Card>
        <ModalSendEmail
          show={this.state.isModalSendEmail}
          id={this.props.id}
          token={this.props.token}
          insuredEmail={this.props.insuredEmail}
          repairerEmail={this.props.repairerEmail}
          insuredName={this.props.insuredName}
          kind={this.props.kind}
          repairerName={this.props.repairerName}
          brand={this.props.brand}
          model={this.props.model}
          licensePlate={this.props.licensePlate}
          dateAppointment={this.props.dateAppointment}
          hourAppointment={this.props.hourAppointment}
          visioInstant={this.props.visioInstant}
          messageEmail={this.props.messageEmail}
          messageEmailRepairer={this.props.messageEmailRepairer}
          agencyEmail={this.props.agencyEmail}
          getFolder={this.props.getFolder}
          onClose={() =>
            this.setState({
              isModalSendEmail: false,
            })
          }
        />
        <ModalSendSMS
          show={this.state.isModalSendSMS}
          id={this.props.id}
          token={this.props.token}
          insuredPhone={this.props.insuredPhone}
          repairerPhone={this.props.repairerPhone}
          insuredName={this.props.insuredName}
          kind={this.props.kind}
          repairerName={this.props.repairerName}
          brand={this.props.brand}
          model={this.props.model}
          licensePlate={this.props.licensePlate}
          dateAppointment={this.props.dateAppointment}
          hourAppointment={this.props.hourAppointment}
          visioInstant={this.props.visioInstant}
          messageSMS={this.props.messageSMS}
          messageSMSRepairer={this.props.messageSMSRepairer}
          getFolder={this.props.getFolder}
          onClose={() =>
            this.setState({
              isModalSendSMS: false,
            })
          }
        />
        <ModalAppointment
          show={this.state.isModalAppointment}
          id={this.props.id}
          dateAppointment={this.props.dateAppointment}
          hourAppointment={this.props.hourAppointment}
          visioInstant={this.props.visioInstant}
          appointmentCanceled={this.props.appointmentCanceled}
          appointmentExpertId={this.props.appointmentExpertId}
          getFolder={this.props.getFolder}
          onClose={() =>
            this.setState({
              isModalAppointment: false,
            })
          }
        />
        <Loader show={this.state.isLoad} />
      </>
    );
  }
}
